import { useMemo } from 'react';
import { differenceInSeconds } from 'date-fns';
import { parseISOorDate } from 'infrastructure/functions/parse-iso-or-date';
import { useTranslation } from 'react-i18next';
import { useAssignedSecondsWatcher } from 'infrastructure/hooks/conversation/use-assigned-seconds-watcher';

const getSeconds = (date: Date | string) => {
  const assignedDate = parseISOorDate(date);
  const seconds = differenceInSeconds(new Date(), assignedDate);
  return seconds;
};

interface IProps {
  assignedAt?: string | Date | null;
  assignedByFullname?: string | null;
}

export const useAssignedLabels = ({
  assignedAt,
  assignedByFullname,
}: IProps) => {
  const { t } = useTranslation();
  const { assignedSeconds, isOverTime } = useAssignedSecondsWatcher({
    assignedAt,
  });

  const assignByLabel = `${t('labels.assignedBy')}: ${assignedByFullname}`;

  const assignTimeLabel = useMemo(() => {
    let label = ``;

    if (assignedAt) {
      const seconds = getSeconds(assignedAt);
      let timeAgo: string | undefined;
      if (seconds < 60) {
        timeAgo = `${t('labels.lessThanAMinuteAgo')}`;
      } else {
        const minutes = (seconds / 60).toFixed();
        timeAgo = `${minutes} ${t('labels.minutes')} ${t('labels.ago')}`;
      }
      const assigneeLabel = `${t('labels.assigned')}: ${timeAgo}`;
      label = `${assigneeLabel}`;
    }

    return label;
  }, [assignedSeconds, assignedAt]);

  return { assignByLabel, assignTimeLabel, isOverTime };
};
